<template>
	<div class="order-body">
		<div class="fx-header goback">
            <p>自提点管理</p>
        </div>
		<div class="order-body" style="min-height:0">
			<Search :ids="ids" :customList="customList" :tableData='tableData' :AuthorityList='AuthorityList' ref='searchRef' @handleSearch="handleSearch" @modifySuc="modifySuc"/>
			<MainTable
				ref='table'
				:size='size'
				:page='page'
				:tableData='tableData'
				:totalCount='totalCount'
				:AuthorityList='AuthorityList'
				@modifySuc="modifySuc"
				@handleSize='handleSizeChange'
				@handlePage='handlePageChange'
				@selectIds="selectIdsChange"
			/>
		</div>
	</div>
</template>

<script>
import Search from '@/components/selfDelivery/Search.vue'
import MainTable from '@/components/selfDelivery/MainTable.vue'
export default {
	name: 'selfDelivery',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'01_0008_0001_00': false,
				'01_0008_0002_00': false,
				'01_0008_0003_00': false
			},
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			ids: [],
			customList: [],
			disabledflag: -1,
			shop: [],
			customer: [],
			category: [],
			level: [],
			normal: [],
			special: [],
			shopCategoryBigId: '0',
			shopCategorySmallId: '0',
			product: '',
			spec: '',
			activeName: 'first',
			templateType: -1,
			templateName: '',
			temTotalCount: 0,
			temNormalCount: 0,
			temSpecCount: 0,
			templateList: [],
			key: '',
			province: '',
			city: '',
			district: ''
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '2-9')
		this.getAuthority('01_0008_0000_00')
		if (this.$route.query.shopid) {
			this.shop = [this.$route.query.shopid]
		}
		this.openPage()
	},
	methods: {
		deleteTemplate (row) {
			if (row.defaultFlag) {
				this.$alert('请更换默认模板后,再删除', '该模板为默认模板,无法删除', {
					confirmButtonText: '确定',
					callback: action => {}
				})
				return false
			}
			let that = this
			this.$confirm('删除将不可恢复, 是否删除?', '提示', {
				confirmButtonText: '删除',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let params = {
					id: row.id,
					type: row.type
				}
				that.$store.dispatch('requestPost', {
					url: `${that.$fxBaseApi.urlQIVShop}/freightTemplate/remove`,
					data: params
				}).then(res => {
					if (res.result === true) {
						that.$message.success('删除成功')
						that.getTemplate()
					} else {
						that.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		selectIdsChange (ids) {
			this.ids = ids
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		openPage () {
			this.findOrderList()
		},
		modifySuc () {
			this.ids = []
			this.findOrderList()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.key = data.key
			this.province = data.province
			this.city = data.city
			this.district = data.district
			this.page = 1
			this.findOrderList()
		},
		getTemplate () {
			let params = {
				name: this.templateName,
				type: this.templateType
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/list/get`,
				data: params
			}).then(res => {
				this.temTotalCount = res.data.totalFreightTemplateCount
				this.temNormalCount = res.data.normalFreightTemplateCount
				this.temSpecCount = res.data.specialProductFreightTemplateCount
				if (res.data.freightTemplateDTOList !== null) {
					res.data.freightTemplateDTOList.forEach(e => {
						e.showFlag = false
						e.detailList = []
					})
				}
				this.templateList = res.data.freightTemplateDTOList || []
			})
		},
		findOrderList () {
			this.tableData = []
			let params = {
				page: this.page,
				size: this.size,
				key: this.key,
				province: this.province,
				city: this.city,
				district: this.district
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/getShopSelfPickInfo`,
				data: params
			}).then(res => {
				if (res.recordList !== null) {
					res.recordList.forEach(e => {
						e.selfPickMoney = this.$fxUtils.toFixedSHW(e.selfPickMoney, 2)
					})
				}
				this.totalCount = res.recordCount
				this.tableData = res.recordList || []
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.el-dropdown {
		vertical-align: top;
	}
	.el-dropdown + .el-dropdown {
		margin-left: 15px;
	}
	.el-icon-arrow-down {
		font-size: 12px;
	}
	.type-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 15px;
	}
	.template-list {
		flex: 1;
		margin-top: 15px;
		color: #333;
		overflow: hidden
		overflow-y: auto
		.template-li {
			border: 1px solid #EDEFFC;
			box-shadow: 0px 1px 4px 1px rgba(199, 199, 199, 0.23);
			border-radius: 2px;
			margin-bottom: 15px;
			.template-head {
				display: flex;
				height: 38px;
				padding: 0 10px;
				background-color: #EFEFEF;
				align-items: center;
				cursor: pointer
				img {
					width: 16px;
					height: 16px;
					margin-right: 5px;
				}
				.span-one, .span-four, .span-six {
					margin-right: 80px
				}
				.span-one {
					font-weight: bold
				}
				.span-six {
					color: #595959
				}
				.head-right {
					margin-left: auto;
				}
			}
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
